import { Component } from '@angular/core';

@Component({
  selector: 'app-notification-process',
  standalone: true,
  imports: [],
  templateUrl: './notification-process.component.html',
  styleUrl: './notification-process.component.scss'
})
export class NotificationProcessComponent {

}
